module.exports = __webpack_public_path__ + "img/arrow-left.4dc02020.jpg";